import {
  ISource,
  ISourceConfigurationItem,
} from '@principle-theorem/practice-migrations/interfaces';
import { find } from 'lodash';

/**
 * Source configuration items generated and overwritten by the add-database job.
 * They are outputs of provisioning, not operator inputs, so editing them by hand
 * either has no effect or points the migration at a database that does not exist.
 */
export const SYSTEM_OWNED_CONFIGURATION_ITEMS = [
  'database connection name',
  'database name',
  'database username',
  'database password',
];

export function isEditableConfigurationItem(
  item: ISourceConfigurationItem
): boolean {
  return !SYSTEM_OWNED_CONFIGURATION_ITEMS.includes(item.name);
}

export function getConfigurationItem<T>(
  source: ISource,
  name: string,
  defaultValue: T
): string | T {
  return (
    find(
      source.configuration,
      (configuration) => configuration.name.toLowerCase() === name.toLowerCase()
    )?.value ?? defaultValue
  );
}

export function updateConfigurationItem(
  source: ISource,
  name: string,
  value: string
): ISource {
  const hasConfigurationItem = source.configuration.some(
    (config) => config.name.toLowerCase() === name.toLowerCase()
  );

  if (!hasConfigurationItem) {
    const configuration = [
      ...source.configuration,
      {
        name,
        description: '',
        value,
      },
    ];

    return {
      ...source,
      configuration,
    };
  }

  const configuration = source.configuration.map((config) => {
    return config.name.toLowerCase() === name.toLowerCase()
      ? { ...config, value }
      : config;
  });

  return {
    ...source,
    configuration,
  };
}
